module.exports = __webpack_public_path__ + "static/media/uiux skill.e275341a.png";